import { useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { newsArticles } from '@/mocks/news';

export default function ShareBar() {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const article = newsArticles.find((a) => a.id === id);
  const [copied, setCopied] = useState(false);
  const [showWechatTip, setShowWechatTip] = useState(false);

  if (!article) return null;

  const pageUrl =
    typeof window !== 'undefined'
      ? window.location.origin + location.pathname
      : `http://lide18.com.cn${location.pathname}`;
  const shareTitle = encodeURIComponent(article.title);
  const shareUrl = encodeURIComponent(pageUrl);

  const weiboShareUrl = `https://service.weibo.com/share/share.php?url=${shareUrl}&title=${shareTitle}&pic=${encodeURIComponent(article.coverImage)}`;
  const qqShareUrl = `https://connect.qq.com/widget/shareqq/index.html?url=${shareUrl}&title=${shareTitle}&desc=${encodeURIComponent(article.excerpt)}&pics=${encodeURIComponent(article.coverImage)}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(pageUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const textarea = document.createElement('textarea');
      textarea.value = pageUrl;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const shareButtons = [
    {
      name: '微博',
      icon: 'ri-weibo-line',
      color: 'hover:bg-[#E6162D]/15 hover:text-[#E6162D] hover:border-[#E6162D]/40',
      href: weiboShareUrl,
      target: '_blank',
      rel: 'nofollow noopener',
    },
    {
      name: '微信',
      icon: 'ri-wechat-line',
      color: 'hover:bg-[#07C160]/15 hover:text-[#07C160] hover:border-[#07C160]/40',
      onClick: () => setShowWechatTip(!showWechatTip),
    },
    {
      name: 'QQ',
      icon: 'ri-qq-line',
      color: 'hover:bg-[#12B7F5]/15 hover:text-[#12B7F5] hover:border-[#12B7F5]/40',
      href: qqShareUrl,
      target: '_blank',
      rel: 'nofollow noopener',
    },
    {
      name: copied ? '已复制' : '复制链接',
      icon: copied ? 'ri-check-line' : 'ri-link',
      color: copied
        ? 'hover:bg-primary-500/15 hover:text-primary-500 hover:border-primary-500/40'
        : 'hover:bg-primary-500/15 hover:text-primary-500 hover:border-primary-500/40',
      onClick: handleCopy,
    },
  ];

  return (
    <div className="w-full max-w-3xl mx-auto px-6 mt-6 relative">
      <div className="flex items-center justify-center gap-3 md:gap-4 flex-wrap">
        <div className="flex items-center gap-2 text-foreground-400 text-xs mr-1">
          <i className="ri-share-forward-line text-sm"></i>
          <span className="whitespace-nowrap">分享到</span>
        </div>
        {shareButtons.map((btn) => {
          const sharedProps = {
            className: `flex items-center gap-1.5 px-4 py-2 rounded-full border border-foreground-200/20 bg-background-50 text-foreground-500 text-xs font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${btn.color}`,
          };

          if (btn.href) {
            return (
              <a
                key={btn.name}
                href={btn.href}
                target={btn.target}
                rel={btn.rel}
                {...sharedProps}
              >
                <i className={`${btn.icon} text-sm`}></i>
                <span>{btn.name}</span>
              </a>
            );
          }

          return (
            <button
              key={btn.name}
              onClick={btn.onClick}
              {...sharedProps}
            >
              <i className={`${btn.icon} text-sm`}></i>
              <span>{btn.name}</span>
            </button>
          );
        })}
      </div>

      {/* WeChat tooltip */}
      {showWechatTip && (
        <div className="absolute left-1/2 -translate-x-1/2 top-full mt-3 z-20">
          <div className="bg-background-800 border border-foreground-200/30 rounded-xl p-5 text-center shadow-lg backdrop-blur-sm">
            <p className="text-foreground-200 text-sm mb-2 font-medium">分享到微信</p>
            <p className="text-foreground-400 text-xs">请复制页面链接，在微信中打开即可分享</p>
            <button
              onClick={handleCopy}
              className="mt-3 px-4 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium cursor-pointer transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              {copied ? '已复制链接' : '一键复制链接'}
            </button>
            <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-3 h-3 rotate-45 bg-background-800 border-l border-t border-foreground-200/30"></div>
          </div>
        </div>
      )}
    </div>
  );
}
